import { render, staticRenderFns } from "./PagesExample.vue?vue&type=template&id=2b8c9fe7"
import script from "./PagesExample.vue?vue&type=script&lang=js"
export * from "./PagesExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports